module.exports = __webpack_public_path__ + "static/media/a1lg.68115019.png";